<template>
  <div class="tab-container">
    <div class="tab-section">
      <div class="title">{{ $t("app.campaign.settings.tabs.preview.title") }}</div>
      <p class="muted">
        {{ $t("app.campaign.settings.tabs.preview.info") }}
      </p>
      <Button class="primary" :label="$t('app.campaign.settings.tabs.preview.buttons.modify')" @click="goEditCampaign()" />
      <CampaignCard v-model="props.data" @changeImage="(event) => emits('changeImage', event)" @changePublicName="(event) => emits('changePublicName', event)" @changeJobTitle="(event) => emits('changeJobTitle', event)" @changeJobDescription="(event) => emits('changeJobDescription', event)" @toggleError="(val) => emits('toggleError', val)" mode="preview" :text_colour="data.text_colour" :elem_colour="data.elem_colour" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.tab-container {
  .tab-section {
    padding-bottom: 0 !important;
    .title {
      font-family: $bioSans;
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 6px;
    }

    .toggle-container {
      margin-top: 16px;
    }

    .date {
      margin: 16px 0;

      .bold {
        text-transform: uppercase;
        margin-bottom: 4px;
      }
    }

    .input-inline {
      margin-top: 16px;
    }

    .btn {
      margin: 16px 0;
    }

    .campaign-card {
      margin: 0;
      width: unset;
    }
  }
}
</style>

<script setup>
import { useRouter } from "vue-router";
import CampaignCard from "@/components/global/CampaignCard.vue";

const router = useRouter();
const route = useRoute();

const emits = defineEmits(["changeImage", "changePublicName", "changeJobTitle", "changeJobDescription", "toggleError"]);

const props = defineProps({
  data: {
    type: Object,
  },
});

function goEditCampaign() {
  router.push({ name: "editCampaign",
    params: {
      spaceId: route.params.spaceId,
      campaignId: route.params.campaignId || props.data.campaign_id,
      companyId: route.params.companyId,
    },
   });
}
</script>
